<div class="py-5 px-2">
	<div *ngIf="products && products.length > 0"
		 class="fb-filter-product-grid ">
		<ng-container *ngFor="let product of products">
			<fb-search-product-preview class="my-2 border border-[#75787F]/20 shadow md:shadow-md rounded md:rounded-xl"
									   [productListingData]="product"></fb-search-product-preview>
		</ng-container>
	</div>
</div>
